import { mergeClass } from "@/utils/helper";
import CreatableSelect from "react-select/creatable";
import classes from "./Creatable.module.css";
import AsyncCreatableSelect from "react-select/async-creatable";
import { cn } from "@/utils/cn";

const components = {
  DropdownIndicator: null,
};

const CreatableDropdown = ({
  label,
  labelClass = "",
  containerClassName = null,
  className = "",
  dropdownWrapperClassName = "",
  variant = "",
  errorText = "",
  hintText = "",
  isMulti = false,
  isAsync = false,
  height = 32,
  minHeight,
  required = true,
  noOptionsMessage = () => "Type Something and press Enter / Tab",
  ...props
}) => {
  const customStyles = {
    container: (provided) => ({
      ...provided,
      height: height,
    }),
    control: (base, state) => ({
      ...base,
      minHeight: height,
      height: height,
      border: state.isDisabled
        ? "0.5px solid var(--gray-v5)"
        : "0.5px solid var(--blue-dark)",
      boxShadow: "none",
      backgroundColor: "var(--white-color)",
      borderRadius: "5px",
      fontFamily: "var(--inter)",
      fontSize: "16px",
      fontWeight: "300",
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
      zIndex: 9998,
      "&:hover": {
        border: state.isDisabled
          ? "0.5px solid var(--gray-v5)"
          : "0.5px solid var(--blue-dark)",
      },
    }),
    valueContainer: (base, state) => ({
      ...base,
      height: height,
    }),
    indicatorsContainer: (base, state) => ({
      ...base,
      height: height,
    }),
    placeholder: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    input: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    singleValue: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    multiValue: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
      borderRadius: 4,
      height: height - 8,
    }),
    multiValueLabel: (base, state) => {
      const fontSize = Math.max(height / 2.5, 6);
      return {
        ...base,
        padding: 2,
        fontSize: fontSize,
      };
    },
    menuPortal: (styles) => ({
      ...styles,
      zIndex: 9998,
    }),
  };

  return (
    <div>
      <div className={`grid grid-cols-3 gap-3 ${containerClassName}`}>
        <label
          htmlFor={`input${label}`}
          className={cn(
            "text-black",
            props.isDisabled ? "text-gray-400" : "",
            labelClass
          )}
        >
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
        <div
          className={cn(
            "ml-3 col-span-2 flex relative border-none rounded-lg transition-all",
            dropdownWrapperClassName
          )}
        >
          {isAsync ? (
            <AsyncCreatableSelect
              id={`input${label}`}
              styles={customStyles}
              className={mergeClass(classes.dropdown)}
              menuPortalTarget={document.body}
              noOptionsMessage={noOptionsMessage}
              {...props}
            />
          ) : (
            <CreatableSelect
              components={components}
              noOptionsMessage={noOptionsMessage}
              isMulti={isMulti}
              id={`input${label}`}
              styles={customStyles}
              className={mergeClass(classes.dropdown)}
              menuPortalTarget={document.body}
              isClearable
              {...props}
            />
          )}
        </div>
      </div>
      {hintText && (
        <div
          className={`grid grid-cols-3 gap-3 ${containerClassName}`}
          data-variant={variant}
        >
          <div></div>
          <div
            className={cn(
              "ml-3 col-span-2 mt-2 text-gray-600 mb-0.5 w-[450px]",
              dropdownWrapperClassName
            )}
          >
            {hintText}
          </div>
        </div>
      )}
      {errorText && (
        <div
          className={`grid grid-cols-3 gap-3 ${containerClassName}`}
          data-variant={variant}
        >
          <div></div>
          <div
            className={cn(
              "ml-3 col-span-2 mt-2 text-[red] mb-0.5 w-[450px]",
              dropdownWrapperClassName
            )}
          >
            {errorText}*
          </div>
        </div>
      )}
    </div>
  );
};

export default CreatableDropdown;
